
import Rest from './Rest';

export class SampleService {

    static async getProjects(params){
        return Rest.post(`/project-name-list`,  params)
          .then(response => {
            return response.data;  
          })
          .catch(error => {
            console.error('Error of getting projects:', error.response?.data || error.message);
            throw error;
        });
    }

    
    static async getDonors(params){
        return Rest.post(`/fetch-donors-samples`,  params)
          .then(response => {
            return response.data;  
          })
          .catch(error => {
            console.error('Error of getting donor details:', error.response?.data || error.message);
            throw error;
        });
    }

    static async addSampleRequest(sampleRequest){
      
      return Rest.post(`/add-sample-request`,sampleRequest)
        .then(response =>{ 
          return response.data;
        })
        .catch(error => {
          console.error('Error occured while adding new sample request', error)
        })
    }

    //for draft
    static async updateSampleRequest(sampleRequest){
      
      return Rest.post(`/update-sample-request`,sampleRequest)
        .then(response =>{ 
          return response.data;
        })
        .catch(error => {
          console.error('Error occured while updating drafted sample request', error)
        })
    }
    static async getSampleTypes(params){
        return Rest.get(`/sample-list`)
          .then(response => {
            return response.data;  
          })
          .catch(error => {
            console.error('Error of getting sample types:', error.response?.data || error.message);
            throw error;
        });
    }

    static async sampleCustomFields(params){
        return Rest.post(`/sample-custom-fields`, {sample_id: params})
          .then(response => {
            return response.data;  
          })
          .catch(error => {
            console.error('Error of getting custom fields:', error.response?.data || error.message);
            throw error;
        });
    }

    static async fetchDonors(params){
      return Rest.post(`/fetch-donor-id`,  params)
        .then(response => {
          return response.data;  
        })
        .catch(error => {
          console.error('Error of getting donor Ids:', error.response?.data || error.message);
          throw error;
      });
    }


    static async fetchAutoPopulateData(flag, params){
        if (!flag) return [];

        let results = [];
        let response = {};

        try {
          switch (flag) {
            case 'project_name':
              response = await SampleService.getProjects(params);
              results = response.name || [];
              break;
        
            case 'preferred_donor':
            case 'alternate_donor':
            case 'excluded_donor':
              response = await SampleService.fetchDonors(params);
              results = Array.isArray(response.donor_id)
                ? response.donor_id.map(d => `${d.donor_id}`)
                : [];
              break;
        
            default:
              break;
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }

        return results;
    }
    static async getRaceOptions( ){
 
      return Rest.get(`/get-race-options`)
        .then(response => {
          return response.data;  
        })
        .catch(error => {
          console.error('Error of getting race options:', error.response?.data || error.message);
          throw error;
      });
    }
}